module.exports = __webpack_public_path__ + "img/python_variable_tracing.479f27ad.png";